import React from 'react';
import classNames from 'classnames';
import mime from 'mime-types';
import pdf from '../../../CustomerDetails/assets/pdf.svg';
import jpg from '../../../CustomerDetails/assets/jpg.svg';
import gif from '../../../CustomerDetails/assets/gif.svg';
import png from '../../../CustomerDetails/assets/png.svg';
import word from '../../../CustomerDetails/assets/Word.svg';
import defaultIcon from '../../../CustomerDetails/assets/defFile.svg';
import styles from './styles.module.scss';

const FileIcon = ({fileExtension, size}) => {
  const getIcon = () => {
    switch (mime.lookup(fileExtension)) {
      case 'application/pdf':
        return pdf;
      case 'image/gif':
        return gif;
      case 'image/jpeg':
      case 'image/jpg':
        return jpg;
      case 'image/tiff':
      case 'image/png':
        return png;
      default:
        return fileExtension === 'doc' || fileExtension === 'docx' ? word : defaultIcon;
    }
  };

  return (
    <div className={classNames(styles.imageContainer, {[styles.smallSize]: size === 'sm'})}>
      <img src={getIcon()} alt="icon" className={styles.image}/>
    </div>
  );
};

export default FileIcon;